import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogAfinComponent } from 'src/app/pages/cotiza/cotiza-components/dialog-afin/dialog-afin.component';
import { environment } from 'src/environments/environment';
import { CreditTypeDialogComponent } from '../credit-type-dialog/credit-type-dialog.component';
import { TypeQuote } from 'src/app/utils/utils';

@Component({
  selector: 'app-credit-dialog',
  templateUrl: './credit-dialog.component.html',
  styleUrls: ['./credit-dialog.component.scss']
})
export class CreditDialogComponent {

  templateSuffix = environment.templateSuffix;


  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreditDialogComponent>,
  ){

  }
  
  public goLeasing(){
    this.dialogRef.close(TypeQuote.Leasing)
  }

  public goCredit(){
    this.dialogRef.close(TypeQuote.credit)
  }
}
